export default "__VITE_ASSET__BoiwM1lD__"